export enum EnglishProficiency {
	BIGINNER = 'beginner',
	INTERMEDIATE = 'intermediate',
	ADVANCED = 'advanced'
}
